import { getCookie, setCookie } from '@ui/helpers/getCookie'
import { useState } from 'react'

export function useCookieState<T extends string = string>(
  key: string,
  initialValue: T
): [T | string, (value: T) => void] {
  const getInitialValue = (): T | string => {
    // if we on the server just use an initial value
    if (typeof window === 'undefined') return initialValue

    return getCookie(key) || initialValue
  }

  // get initial state value on component mounts
  const [value, setValue] = useState<T | string>(getInitialValue)

  // encode and save the new cookie value
  const setNextValue = (value: T) => {
    setCookie(key, value, 0)
    setValue(value)
  }

  return [value, setNextValue]
}
